var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_410_1793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.97191 10.8047L0.199188 6.10634C-0.0667214 5.84784 -0.0667214 5.42709 0.199188 5.16584L1.16328 4.22534C1.42919 3.96684 1.86146 3.96684 2.12737 4.22534L5.45464 7.51709L12.8715 0.195218C13.1374 -0.0632822 13.5696 -0.0632822 13.8356 0.195218L14.7996 1.13572C15.0656 1.39422 15.0656 1.81634 14.7996 2.07484L5.93601 10.8075C5.6701 11.0646 5.23919 11.0646 4.97191 10.8047Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_410_1793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.a0a43dabb514d745c917697f6a8f75c2.svg";
export { ForwardRef as ReactComponent };